import { Video } from '@components';
import styles from './Carousel.module.scss';

const VideoSlide = ({ video, type, name, isImagesLaidOut = false }) => {
	return (
		video && (
			<div className={styles['video-container']} data-product-type={type} data-product-name={name}>
				<Video video={video} className={isImagesLaidOut ? styles['images-with-border'] : ''} />
			</div>
		)
	);
};

export default VideoSlide;
